import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getApiBaseUrl } from '../../services/api';
import { getImageUrl } from '../../utils/imageUrl';
import LanguageSwitcher from './LanguageSwitcher';

const LandingNavbar = () => {
  const { t } = useTranslation('landing');
  const navigate = useNavigate();
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [logoUrl, setLogoUrl] = useState(null);
  const isHome = location.pathname === '/';

  useEffect(() => {
    const base = getApiBaseUrl();
    const url = base ? `${base}/api/banners?type=website&active=true` : '/api/banners?type=website&active=true';
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        if (!data || !data.success || !Array.isArray(data.banners)) return;
        const logoBanner = data.banners.find((b) => (b.title || '').toLowerCase().includes('logo'));
        if (logoBanner && logoBanner.image_url) setLogoUrl(logoBanner.image_url);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const goHomeSection = (id) => {
    setIsMobileMenuOpen(false);
    if (isHome) {
      const element = document.getElementById(id);
      if (element) element.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    navigate({ pathname: '/', hash: `#${id}` }, { state: { scrollTo: id } });
  };

  const handleLogoClick = () => {
    setIsMobileMenuOpen(false);
    if (isHome) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    navigate('/');
  };

  return (
    <nav className={`landing-navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <div className="logo" onClick={handleLogoClick}>
          {logoUrl ? (
            <img src={getImageUrl(logoUrl) || logoUrl} alt="Syllera" className="landing-logo-img" />
          ) : (
            <span className="material-icons">school</span>
          )}
          <span>Syllera</span>
        </div>
        <div className={`nav-menu ${isMobileMenuOpen ? 'open' : ''}`}>
          <a href="/#features" onClick={(e) => { e.preventDefault(); goHomeSection('features'); }}>{t('nav.features')}</a>
          <a href="/#how-it-works" onClick={(e) => { e.preventDefault(); goHomeSection('how-it-works'); }}>{t('nav.howItWorks')}</a>
          <a href="/#pricing" onClick={(e) => { e.preventDefault(); goHomeSection('pricing'); }}>{t('nav.pricing')}</a>
          <a href="/#testimonials" onClick={(e) => { e.preventDefault(); goHomeSection('testimonials'); }}>{t('nav.reviews')}</a>
          <a href="/resources" onClick={(e) => { e.preventDefault(); setIsMobileMenuOpen(false); navigate('/resources'); }}>{t('nav.resources')}</a>
          <a href="/business" onClick={(e) => { e.preventDefault(); setIsMobileMenuOpen(false); navigate('/business'); }}>{t('nav.business')}</a>
        </div>
        <div className="nav-actions">
          <LanguageSwitcher className="landing-language-switcher" />
          <button className="btn-login" onClick={() => goHomeSection('login')}>{t('nav.login')}</button>
          <button className="btn-primary" onClick={() => { setIsMobileMenuOpen(false); navigate('/signup'); }}>{t('nav.startLearning')}</button>
          <button className="mobile-menu-toggle" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu">
            <span className="material-icons">{isMobileMenuOpen ? 'close' : 'menu'}</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default LandingNavbar;
